import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/venda-externa')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_venda_venda_externa }) =>
                isPermissionParcialOrFull(upp_venda_venda_externa),
        }),
});
